export var spacing = {
    /** 4px */
    extraTight: '4px',
    /** 8px */
    tight: '8px',
    /** 12px */
    snug: '12px',
    /** 16px */
    default: '16px',
    /** 24px */
    loose: '24px',
    /** 32px */
    extraLoose: '32px',
    /** 48px */
    ultraLoose: '48px'
};
//# sourceMappingURL=spacing.js.map